import config from '@/config';
import fetchWrapper from '@/services/fetchWrapper.service';

const LAST_CONTEXT_STORAGE_KEY = 'mandatory_popup_last_context';

const isBrowser = typeof window !== 'undefined';

const safeJsonParse = (value) => {
  try {
    return value ? JSON.parse(value) : null;
  } catch (_error) {
    return null;
  }
};

function rememberLastContext(payload = {}) {
  if (!isBrowser) {
    return;
  }
  const normalized = {
    title: payload?.title ?? null,
    image: payload?.image ?? null,
    containerType: payload?.containerType ?? null,
  };
  try {
    window.localStorage.setItem(LAST_CONTEXT_STORAGE_KEY, JSON.stringify(normalized));
  } catch (_error) {
    // Swallow storage errors silently
  }
}

function getLastContext() {
  if (!isBrowser) {
    return { title: null, image: null, containerType: null };
  }
  const stored = safeJsonParse(window.localStorage.getItem(LAST_CONTEXT_STORAGE_KEY));
  if (!stored || typeof stored !== 'object') {
    return { title: null, image: null, containerType: null };
  }
  return {
    title: stored.title ?? null,
    image: stored.image ?? null,
    containerType: stored.containerType ?? null,
  };
}

function clearLastContext() {
  if (!isBrowser) {
    return;
  }
  try {
    window.localStorage.removeItem(LAST_CONTEXT_STORAGE_KEY);
  } catch (_error) {
    // ignore
  }
}

function createMandatoryPopupResult(body, options = {}) {
  const { useStoredContext = false, clearStoredContext = false } = options;
  const payload = { ...body };

  if (useStoredContext) {
    const context = getLastContext();
    if (payload.title === undefined) {
      payload.title = context.title ?? null;
    }
    if (payload.image === undefined) {
      payload.image = context.image ?? null;
    }
    if (payload.containerType === undefined) {
      payload.containerType = context.containerType ?? null;
    }
  }

  if (payload.title === undefined) {
    payload.title = null;
  }
  if (payload.image === undefined) {
    payload.image = null;
  }
  if (payload.containerType === undefined) {
    payload.containerType = null;
  }

  const request = fetchWrapper.post(`${config.apis.api.url}/mandatory-popup/results`, {
    body: payload,
    contentType: 'json',
  });

  if (clearStoredContext) {
    request.finally?.(() => clearLastContext());
  }

  return request;
}

const MandatoryPopupResultsService = {
  createMandatoryPopupResult,
  rememberLastContext,
  getLastContext,
  clearLastContext,
};

export default MandatoryPopupResultsService;
